import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { saveForm } from "editor/actions/status";
import { insertImage } from "editor/actions/blocks";
import ImageEditor from "components/library/ImageEditor";
import { IMAGE_TYPES } from "config/constants";

class BlockImageEditor extends React.Component {
  constructor(props) {
    super(props);
    this.onSuccess = this._onSuccess.bind(this);
  }

  imageValidator(image, imageRequirements) {
    const isValid =
      image.orig_height >= imageRequirements.minHeight ||
      image.orig_width >= imageRequirements.minWidth;
    if (!isValid) {
      throw new Error(
        `Please upload an image that's at least ${imageRequirements.minWidth} pixels wide or ${imageRequirements.minHeight} pixels tall.`
      );
    }
  }

  uploadHelpText(imageRequirements) {
    const imageNames = Object.values(IMAGE_TYPES)
      .map(x => x.name)
      .join(" or ");
    return `This image must be at least ${imageRequirements.minWidth} tall or wide and formatted as ${imageNames}`;
  }

  _onSuccess(image) {
    return new Promise(resolve => {
      this.props.insertImage({
        src: image.base_image_url,
        alt_text: image.alt_text,
        image_id: image.id,
      });
      return this.props.saveForm().then(() => {
        resolve();
      });
    });
  }

  render() {
    return (
      <ImageEditor
        {...this.props}
        redirectTo={`/editor/${this.props.match.params.type}/${this.props.match.params.id}/`}
        onSuccess={this.onSuccess}
        skipCropping={true}
        imageValidator={this.imageValidator}
        uploadHelpText={this.uploadHelpText}
        imageRequirements={{
          minWidth: 650,
          minHeight: 650,
        }}
      />
    );
  }
}

BlockImageEditor.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      type: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    }),
  }),
  saveForm: PropTypes.func.isRequired,
  insertImage: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  saveForm,
  insertImage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BlockImageEditor);
